import { render, staticRenderFns } from "./EdFlowItem.vue?vue&type=template&id=1c2a4430&scoped=true&"
import script from "./EdFlowItem.vue?vue&type=script&lang=js&"
export * from "./EdFlowItem.vue?vue&type=script&lang=js&"
import style0 from "./EdFlowItem.vue?vue&type=style&index=0&id=1c2a4430&prod&lang=scss&scoped=true&"
import style1 from "./EdFlowItem.vue?vue&type=style&index=1&id=1c2a4430&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a4430",
  null
  
)

export default component.exports